module.exports = __webpack_public_path__ + "static/img/issued.16798fe2.svg";